import {APP_INITIALIZER, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {BrowserModule, Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule} from '@ngx-translate/core';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import { AbilityModule } from '@casl/angular';
import { Ability, PureAbility } from '@casl/ability';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import {LayoutModule} from './layout/layout.module';
import {SettingsModule} from './modules/settings/settings.module';
import {DashboardModule} from './modules/dashboard/dashboard.module';
import {ControlliModule} from './modules/controlli/controlli.module';
import {AmministrazioneModule} from './modules/amministrazione/amministrazione.module';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {initializeKeycloak} from "./config/keycloak.config";
import {KeycloakBearerInterceptor, KeycloakService} from "keycloak-angular";
import { ParametriModule } from './modules/parametri/parametri.module';
import { A11yModule } from '@angular/cdk/a11y';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UuidInterceptor } from './core/interceptors/uuid.interceptor';
import { PuntiCampionamentoModule } from './modules/punti-campionamento/punti-campionamento.module';
import { DateControlloModule } from './modules/date-controllo/date-controllo.module';
import { AcquedottiModule } from './modules/acquedotti/acquedotti.module';
import { WaterSupplyZoneModule } from './modules/water-supply-zone/water-supply-zone.module';
import { AreraAtoModule } from './modules/arera-ato/arera-ato.module';
import { AreraGestoreModule } from './modules/arera-gestore/arera-gestore.module';
import { IstatRegioniModule } from './modules/istat-regioni/istat-regioni.module';
import { IstatComuniModule } from './modules/istat-comuni/istat-comuni.module';
import { PuntiCampionamentoTipologieModule } from './modules/punti-campionamento-tipologie/punti-campionamento-tipologie.module';
import { ElaborazioniModule } from './modules/elaborazioni/elaborazioni.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    A11yModule,
    AppRoutingModule,
    RouterModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'it'
    }),
    CoreModule,
    SharedModule,
    LayoutModule,
    DashboardModule,
    SettingsModule,
    AcquedottiModule,
    AreraAtoModule,
    AreraGestoreModule,
    IstatRegioniModule,
    IstatComuniModule,
    ParametriModule,
    PuntiCampionamentoTipologieModule,
    PuntiCampionamentoModule,
    WaterSupplyZoneModule,
    DateControlloModule,
    ControlliModule,
    AbilityModule,
    AmministrazioneModule,
    ElaborazioniModule
  ],
  providers: [
    Title,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline', subscriptSizing: 'dynamic'}
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService]
    },

    KeycloakService,
    {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UuidInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    },
    { provide: Ability, useValue: new Ability() },
    { provide: PureAbility, useExisting: Ability }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
